import React from 'react';
import {
  getFieldsByCategory,
  PassFieldDefinition,
  PassTypeDefinition,
} from '../../pages/Companies/Passes/passFieldConfig';
import './styles/PassDetailFieldsPanel.css';

type Props = {
  definition: PassTypeDefinition;
};

const PassDetailFieldsPanel: React.FC<Props> = ({ definition }) => {
  const paseFields = getFieldsByCategory(definition, 'PASE');
  const licenciaFields = getFieldsByCategory(definition, 'LICENCIA');

  const renderGroup = (title: string, fields: PassFieldDefinition[]) => {
    if (fields.length === 0) return null;

    return (
      <div className="pass-detail__group">
        <h5 className="pass-detail__group-title">{title}</h5>
        <ul className="pass-detail__list">
          {fields.map((field) => (
            <li key={field.key} className="pass-detail__item">
              {field.label}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <section className="pass-detail" aria-labelledby={`pass-detail-title-${definition.id}`}>
      <div className="pass-detail__head">
        <h4 id={`pass-detail-title-${definition.id}`} className="pass-detail__title">
          Campos requeridos
        </h4>
        <p className="pass-detail__description">{definition.description}</p>
      </div>
      <div className="pass-detail__groups">
        {renderGroup('PASE', paseFields)}
        {renderGroup('LICENCIA', licenciaFields)}
      </div>
    </section>
  );
};

export default PassDetailFieldsPanel;
